<template>
    <div>
        <h3>{{role.label}}</h3>
        <!-- AB#19866 (Phase 2): merchants only see permissions within their granted budget -->
        <p v-if="isMerchant" class="text-muted small mb-3">
            You can assign only the permissions granted to your company. Contact your administrator to change your allowed set.
        </p>
        <template v-for="(item, index) in permissions">
            <b-card :title="index" :key="index" class="innerCard">
                <div class="row">
                    <div class="col-sm-3 mb-1" v-for="(data) in item" :key="data.id">
                        <p class="mb-0">{{data.name }}</p>
                        <b-form-checkbox label="label" :value="data.id"  v-model="state" size="lg" :checked="data.assigned"  switch>
                        </b-form-checkbox>
                    </div>
                </div>
            </b-card>
        </template>
        <div class="row mt-3 justify-content-center" v-if="$can('save-permissions')">
            <b-button size="md"  class="btn btn-success  form-input" v-if="status"  @click="updatePermission(role.id)"> Save </b-button>
        </div>
    </div>
</template>

<script>
import {getPermissions} from "@/helpers/Helpers";
import {http} from "@/config/httpCommon";

    export default {
        async created() {
            this.$store.commit('set', ['showLoader', true]);
            let res = await this.$store.dispatch('getrolepermissions', {id:this.$route.params.id, role_id:this.userRole.id});
            this.permissions = res.data;
            this.role = res.role;
            // AB#19866 (Phase 2): merchants may only manage permissions within their granted budget.
            if (this.isMerchant) {
                await this.applyMerchantBudget();
            }
            this.status = true;
            this.$store.commit('set', ['showLoader', false]);
            for (let data in this.permissions){
                for (let item in this.permissions[data]){
                    if (this.permissions[data][item].assigned ==true){
                         this.state.push(this.permissions[data][item].id);
                    }
                }
            }
            },
        data(){
            return{
                status:false,
                role:{},
                state:[],
                permissions:[],
                mode: { shape:'pill' , size :'lg', "variant": "3d" },
                color: 'primary'
            }
        },
      computed: {
        userRole: function() {
          return this.$store.getters.userRole;
        },
        // AB#19866 (Phase 2): Company Admin / Merchant Group Admin are merchants.
        isMerchant: function() {
          const name = (this.userRole && this.userRole.name || '').toLowerCase();
          return name === 'admin' || name === 'merchantgroupadmin';
        }
      },
        methods:{
            // AB#19866 (Phase 2): keep only permissions inside the merchant's granted budget.
            async applyMerchantBudget() {
                try {
                    const res = await http.get('merchant-role-budget');
                    const allowed = new Set(((res.data && res.data.data) || []).map(p => p.id));
                    const filtered = {};
                    for (const moduleName in this.permissions) {
                        const kept = this.permissions[moduleName].filter(p => allowed.has(p.id));
                        if (kept.length) filtered[moduleName] = kept;
                    }
                    this.permissions = filtered;
                    this.state = this.state.filter(id => allowed.has(id));
                } catch (e) {
                    // Budget fetch failed — tell the merchant; the backend still enforces the budget on save.
                    this.showToast('Could not load your allowed permissions. Saving is still limited to your allowed set.', 'DANGER');
                }
            },
             async updatePermission(id){
                try {
                    this.$store.dispatch('updatePermissions', {
                        id: id,
                        permissions:this.state,
                        ispermission:true
                    }).then(async (res) => {
                        if (res.status == 201){
                          await getPermissions()
                          this.$store.dispatch("getnavigation");
                          this.showToast(res.data.message, "SUCCESS");
                          setTimeout(() => this.$router.push('/roles'), 1000);
                        }
                    });
                }catch (e) {
                    this.showError(e);
                }
            }
        }

    }
</script>

<style scoped>
.innerCard{
    background-color: #eaeef1;
}
</style>